import { INSTAGRAM_METADATA_BY_KEY } from 'utils/metrics';
import InstagramSortableTopPosts from 'components/Posts/Instagram/InstagramSortableTopPosts';
import Stack from 'components/Stack';
import TopPostsDownloadButton from 'components/Posts/TopPostsDownloadButton';
import styled from 'styled-components';
import { useCurrentCountry } from 'utils/hooks';
import { useQuery } from 'react-query';
import { useTopPostsControls } from 'components/Posts/Instagram/useTopPostsControls.hook';

const SectionHeading = styled.div`
    font-size: 18px;
    font-weight: 600;
    display: flex;
    flex-wrap: wrap;
`;

const cardMetrics = [
    [INSTAGRAM_METADATA_BY_KEY.last_week_likes, true],
    [INSTAGRAM_METADATA_BY_KEY.total_post_likes, false],
    [INSTAGRAM_METADATA_BY_KEY.wow, false],
    [INSTAGRAM_METADATA_BY_KEY.create_timestamp, false],
];

function GenericTopPostsDrawer({
    year,
    week,
    name,
    displayQty = 5,
    queryFn,
    queryParams,
}) {
    const country = useCurrentCountry();
    const {
        sortSelect,
        value,
        defaultSortOption,
        visibleOrderedMetrics,
        columnsMenu,
    } = useTopPostsControls({
        week,
        year,
        mixpanelContext: `TopPostsSortSelectInstagram`,
        tableName: `top-posts-section-card-instagram`,
        metrics: cardMetrics,
    });

    const topPostsQuery = useQuery({
        queryKey: [
            'instagram-top-posts',
            {
                ...queryParams,
                year: value.year ? [value.year] : null,
                week: value.week ? [value.week] : null,
                rank_type: [value.apiRankType],
            },
        ],
        queryFn: ({ queryKey }) => queryFn({ data: queryKey[1] }),
        enabled: !!(value.year && value.week),
    });

    return (
        <Stack $space="1rem">
            <SectionHeading>
                <span>Top Posts</span>
                <span css="margin-left: auto;">
                    <TopPostsDownloadButton
                        year={value.year}
                        week={value.week}
                        name={name}
                        country={country}
                        source="instagram"
                        topPostsQuery={topPostsQuery}
                        visibleOrderedMetrics={visibleOrderedMetrics}
                        csvColumns={[
                            { key: 'url', label: 'Post' },
                            ...visibleOrderedMetrics.map(
                                ({ key, tableHeadColumnLabel: label }) => ({
                                    key,
                                    label,
                                }),
                            ),
                        ]}
                    />
                </span>
            </SectionHeading>
            <Stack
                css="display: flex; justify-content: space-between;"
                $space=".25rem"
                $direction="row"
            >
                {sortSelect}
                {columnsMenu}
            </Stack>
            <InstagramSortableTopPosts
                topPostsQuery={topPostsQuery}
                displayQty={displayQty}
                sortOption={defaultSortOption}
                visibleOrderedMetrics={visibleOrderedMetrics}
            />
        </Stack>
    );
}

export default GenericTopPostsDrawer;
